'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EXTERNAL_PATHS = ['blog', 'classes', 'home', 'press-room', 'referral_campaign', 'reserve_class', 'settings/membership', 'studios'];

var EXTERNAL_REGEXP = new RegExp('^/?\\b(' + EXTERNAL_PATHS.join('|') + ')\\b');
var EXTERNAL_DOMAIN_REGEXP = new RegExp('^https?://');

var isExternal = exports.isExternal = function isExternal(path) {
  return EXTERNAL_REGEXP.test(path) || EXTERNAL_DOMAIN_REGEXP.test(path);
};
var isExternalDomain = exports.isExternalDomain = function isExternalDomain(path) {
  return EXTERNAL_DOMAIN_REGEXP.test(path);
};

var redirectTo = exports.redirectTo = function redirectTo(pathname) {
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 301;
  return function (_, replace, cb) {
    return cb(replace({ pathname: pathname, state: { status: status } }));
  };
};

var toExternalHref = exports.toExternalHref = function toExternalHref(href) {
  var secure = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var protocol = secure ? 'https://' : 'http://';
  return href.toLowerCase().indexOf('http') === 0 ? href : '' + protocol + href;
};